import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import CssBaseline from '@material-ui/core/CssBaseline'
import { StylesProvider } from '@material-ui/core/styles'

import App from './App'
import * as serviceWorker from './serviceWorker'
import store from './redux/store'

ReactDOM.render(
  <Provider store={store}>
    <StylesProvider injectFirst>
      <React.StrictMode>
        <CssBaseline />
        <App />
      </React.StrictMode>
    </StylesProvider>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
